import { createSlice } from '@reduxjs/toolkit';
import { addAllBasicExtraReducers } from '../../../utils/action-builder-utils';
import { downloadNewsList } from './news-thunks';
import { NewsState } from './news-types';

const initialState: NewsState = {
  newsRequestStatus: 'idle',
};

const newsSlice = createSlice({
  name: 'features/news',
  initialState: initialState,
  reducers: {
    clearError(state) {
      state.newsError = undefined;
      state.newsRequestStatus = 'idle';
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    addAllBasicExtraReducers(builder, downloadNewsList, 'news');
  },
});

export const newsActions = newsSlice.actions;

export default newsSlice.reducer;
